import { useCallback, useSyncExternalStore } from 'react';
import {
  canInstall,
  showInstallPrompt,
  subscribeInstallPrompt,
} from '../utils/install-prompt';

/**
 * React view over the deferred `beforeinstallprompt` event (see
 * utils/install-prompt.ts — the event is captured at module scope in main.tsx
 * because it fires before React mounts).
 *
 * `installable` is false on iOS and in every browser that has no install prompt
 * API, so callers must treat the install CTA as optional, never as the only way
 * out of a page.
 */
export function useInstallPrompt() {
  const installable = useSyncExternalStore(
    subscribeInstallPrompt,
    canInstall,
    () => false // SSR/prerender: nothing installable there.
  );

  const promptInstall = useCallback(() => showInstallPrompt(), []);

  return { installable, promptInstall };
}
